"use strict";
exports.__esModule = true;
exports.Select = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var ExpandMore_1 = tslib_1.__importDefault(require("@material-ui/icons/ExpandMore"));
var react_1 = tslib_1.__importDefault(require("react"));
var __1 = require("../");
var styles_1 = require("../TextField/styles");
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        placeholderColor: {
            color: theme.palette.text.secondary
        },
        selectFocus: {
            '& :focus': {
                background: 'inherit'
            }
        }
    });
});
function Select(_a) {
    var customBackgroundColor = _a.customBackgroundColor, props = tslib_1.__rest(_a, ["customBackgroundColor"]);
    var classes = useStyles(props);
    var root = styles_1.useTextFieldStyles({ customBackgroundColor: customBackgroundColor }).root;
    var _b = props.id, id = _b === void 0 ? 'no-id' : _b, children = props.children, disabled = props.disabled, error = props.error, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, label = props.label, onChange = props.onChange, placeholder = props.placeholder, _d = props.required, required = _d === void 0 ? false : _d, _e = props.value, value = _e === void 0 ? '' : _e, containerStyle = props.containerStyle, _f = props.IconComponent, IconComponent = _f === void 0 ? ExpandMore_1["default"] : _f, _g = props.variant, variant = _g === void 0 ? 'filled' : _g, _h = props.size, size = _h === void 0 ? 'medium' : _h, rest = tslib_1.__rest(props, ["id", "children", "disabled", "error", "fullWidth", "label", "onChange", "placeholder", "required", "value", "containerStyle", "IconComponent", "variant", "size"]);
    var htmlId = id.replace(/^#\/properties\//, '');
    return (react_1["default"].createElement(__1.FormControl, { disabled: disabled, error: !!error, fullWidth: fullWidth, size: size, style: containerStyle, variant: variant },
        react_1["default"].createElement(core_1.InputLabel, { shrink: true }, label),
        react_1["default"].createElement(core_1.Select, tslib_1.__assign({ id: "select-" + htmlId, name: htmlId }, rest, { IconComponent: IconComponent, className: !value
                ? root + " " + classes.placeholderColor + " " + classes.selectFocus
                : root + " " + classes.selectFocus, displayEmpty: true, onChange: onChange, renderValue: value !== '' || placeholder === ''
                ? undefined
                : function () { return react_1["default"].createElement("div", { "aria-label": "None" }, placeholder); }, value: value }), children),
        react_1["default"].createElement(__1.FormHelperText, null, error)));
}
exports.Select = Select;
//# sourceMappingURL=Select.js.map